document.addEventListener('DOMContentLoaded', function ()  {
  const dropdowns = document.querySelectorAll('.element-dropdown');
  if (!dropdowns.length) {
    return;
  }

  const reset = (current) => {
    dropdowns.forEach(element => {
      if (current && element === current) {
        return;
      }
      /**
       * @type {HTMLBaseElement}
       */
      const select = element.querySelector('.select');
      if (!select) {
        return;
      }
      select.style.display = 'none';
    });
  }

  dropdowns.forEach(dropdown => {
    /**
     * @type {HTMLBaseElement|null}
     */
    const select = dropdown.querySelector('.select');
    if (!select) {
      return;
    }

    /**
     * @type {HTMLBaseElement|null}
     */
    const current = dropdown.querySelector('.current');
    if (!current) {
      return;
    }

    current.addEventListener('click', () => {
      reset(dropdown);

      if (!select.style.display || select.style.display === 'none') {
        select.style.display = 'block';
      } else {
        select.style.display = 'none';
      }
    });

    const options = dropdown.querySelectorAll('.option');

    options.forEach(option => {
      option.addEventListener('click', click => {
        reset();

        /**
         * @type {HTMLBaseElement}
         */
        const value = click.target;
        const placeholder = dropdown.getAttribute('data-placeholder');

        options.forEach(
        /**
         * @param {HTMLBaseElement} active
         */
        (active) => {
          active.classList.remove('active');
        });

        value.classList.add('active');

        /**
         * @type {HTMLInputElement|null}
         */
        const input = dropdown.querySelector('.value');
        if (!input) {
          return;
        }
        input.value = value.getAttribute('data-value');

        /**
         * @type {HTMLBaseElement|null}
         */
        const text = current.querySelector('.text');
        if (!text) {
          return;
        }
        text.innerText = value.innerText || placeholder;
      });
    });
  });
});
